import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';



// dashboard routing
const LandingPage = Loadable(lazy(() => import('Application/pages/TravelPortal/Website/Landing/index')));
const WebsiteGenerateQuote = Loadable(lazy(() => import('Application/pages/TravelPortal/Website/GenerateQuote/index')));
const WebsiteGenerateQuoteRwanda = Loadable(lazy(() => import('Application/pages/TravelPortal/Website/GenerateQuote/index')));

const WebsiteRoutes = {
    path: '/',
    children: [
        {
            path: '',
            element: <LandingPage />
        },
        {
            path: '/travelportal/generate-quote',
            element: <WebsiteGenerateQuote/>
        },
        {
            path: '/travelportal/generate-quote-rw',
            element: <WebsiteGenerateQuoteRwanda/>
        },
    ]
};

export default WebsiteRoutes;